export default {
  dailyEvent: {
    data: null,
    loading: false,
    error: null,
  },
};
